<template>
<div>
    <nav-header
      v-bind:showSearch="p_showSearch"
      v-bind:loginModalFlag="p_loginModalFlag"
      v-bind:showNavbar="p_showNavbar"
      v-on:showLoginModal="p_showLoginModal"
      v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread ref="child">
         <span style="margin-right:10px;" slot="mine">标本管理</span>
    </nav-bread>
    <div class="container">
        <el-container>
          <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 用户订单</p>
            <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
          </div>
<!--            <nav-left  v-bind:activeIndex="p_activeIndex"></nav-left>-->
            <el-container style="margin:0 0 0 20px;">
                <el-main id="UserList">
                    <!-- 统计模块 -->
                    <div class="census" :data="countList" >
                        <!-- 结算统计 -->
                        <div class="accounts">
                             <div class="left">
                                <div class="title">结算统计</div>
                                <div>
                                    <el-row class="number">
                                        <el-col :span="8"><div class="grid-content top">{{countList.chTodayAccount?countList.chTodayAccount:0}}</div>
                                        <div class="grid-content bottom">今日收入</div></el-col>
                                        <el-col :span="8" ><div class="grid-content top">{{countList.chUnfinishedAccount?countList.chUnfinishedAccount:0}}</div>
                                        <div class="grid-content bottom">待结算收入</div></el-col>
                                        <el-col :span="8" ><div class="grid-content top">{{countList.chFinishedAccount?countList.chFinishedAccount:0}}</div>
                                        <div class="grid-content bottom">已结算收入</div></el-col>
                                    </el-row>
                                </div>
                            </div>
                            <div class="right" v-if="this.type == 0">
                                <div class="title">下级经销商结算统计</div>
                                <div>
                                    <el-row class="number">
                                        <el-col :span="8"><div class="grid-content top">{{countList.deTodayAccount?countList.deTodayAccount:0}}</div>
                                        <div class="grid-content bottom">今日收入</div></el-col>
                                        <el-col :span="8" ><div class="grid-content top">{{countList.deUnfinishedAccount?countList.deUnfinishedAccount:0}}</div>
                                        <div class="grid-content bottom">待结算收入</div></el-col>
                                        <el-col :span="8" ><div class="grid-content top">{{countList.deFinishedAccount?countList.deFinishedAccount:0}}</div>
                                        <div class="grid-content bottom">已结算收入</div></el-col>
                                    </el-row>
                                </div>
                            </div>
                        </div>
                        <!-- 订单统计 -->
                        <div class="orders" >
                            <div class="left">
                                <div class="title">订单统计</div>
                                <div>
                                    <el-row class="number">
                                        <span class="nu"  @click="getDataList(1)" :class="{'two':index === 1}">
                                            <el-col :span="8" class="one" ><div class="grid-content top">{{countList.chTodayOrderNum?countList.chTodayOrderNum:0}}</div>
                                            <div class="grid-content bottom">今日订单</div></el-col>
                                        </span>
                                       <span class="nu"  @click="getDataList(2)" :class="{'two':index === 2}">
                                           <el-col :span="8"  class="one"><div class="grid-content top">{{countList.chThisMonthOrderNum?countList.chThisMonthOrderNum:0}}</div>
                                            <div class="grid-content bottom">本月订单</div></el-col>
                                       </span>
                                        <span class="nu" @click="getDataList(3)" :class="{'two':index === 3}">
                                            <el-col :span="8"  class="one"><div class="grid-content top">{{countList.chLastMonthOrderNum?countList.chLastMonthOrderNum:0}}</div>
                                            <div class="grid-content bottom">上月订单</div></el-col>
                                        </span>
                                    </el-row>
                                </div>
                            </div>
                            <div class="right" v-if="this.type == 0">
                                <div class="title">下级经销商订单统计</div>
                                <div>
                                    <el-row class="number">
                                        <span class="nu" @click="getDataList(4)" :class="{'two':index === 4}">
                                            <el-col :span="8" class="one"><div class="grid-content top">{{countList.deTodayOrderNum?countList.deTodayOrderNum:0}}</div>
                                            <div class="grid-content bottom">今日订单</div></el-col>
                                        </span>
                                        <span class="nu" @click="getDataList(5)" :class="{'two':index === 5}">
                                            <el-col :span="8"  class="one"><div class="grid-content top">{{countList.deThisMonthOrderNum?countList.deThisMonthOrderNum:0}}</div>
                                            <div class="grid-content bottom">本月订单</div></el-col>
                                        </span>
                                        <span class="nu" @click="getDataList(6)" :class="{'two':index === 6}">
                                             <el-col :span="8"  class="one"><div class="grid-content top">{{countList.deLastMonthOrderNum?countList.deLastMonthOrderNum:0}}</div>
                                             <div class="grid-content bottom">上月订单</div></el-col>
                                        </span>
                                    </el-row>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 用户列表表单 -->
                    <el-form :inline="true" ref="form" :model="form" label-width="80px" @keyup.enter.native="getDataList()">
                        <el-form-item>
                            <el-input v-model="form.userId" class="mhide"  placeholder="用户id" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="form.channelName" class="mhide" placeholder="推广人名称"  clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="form.orderNum" class="ddh" placeholder="订单号"  clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="form.userName" class="mhide" placeholder="联系人"  clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="form.telNumber" class="mhide" placeholder="联系电话"  clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="form.providerName"  placeholder="检验所名称"  clearable></el-input>
                        </el-form-item>
                        <el-form-item class="mhide">
                            <el-select v-model="form.accountStatus" placeholder="结算状态" filterable clearable>
                            <el-option
                            v-for="item in promotionStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="mhide">
                            <el-date-picker
                            v-model="form.beginTime"
                            type="date"
                            placeholder="起始时间"
                            value-format="yyyy-MM-dd"
                            :picker-options="picker_beginTime">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item class="mhide">
                            <el-date-picker
                            v-model="form.endTime"
                            type="date"
                            placeholder="截止时间"
                            value-format="yyyy-MM-dd"
                            :picker-options="picker_endTime">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="getDataList(0)">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="exportExcel">导出</el-button>
                        </el-form-item>
                         <el-form-item>
                            <el-button type="primary" @click="clearInput">清空</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 用户列表表格 -->
                    <el-table
                        :data="dataList"
                        border
                        v-loading="loading"
                        @selection-change="selectionChangeHandle"
                        style="width: 100%;"
                        :height="tableHeight">
                        <el-table-column
                            type="selection"
                            header-align="center"
                            align="center"
                            width="50">
                        </el-table-column>
                        <el-table-column
                            type="index"
                            align="center"
                            width="50"
                            label="序号">
                        </el-table-column>
                        <el-table-column
                            prop="userId"
                            header-align="center"
                            align="center"
                            label="用户id">
                        </el-table-column>
                        <el-table-column
                            class="orderNum"
                            prop="orderNum"
                            header-align="center"
                            align="center"
                            label="订单号"
                            width="150">
                        </el-table-column>
                        <el-table-column
                            prop="providerName"
                            header-align="center"
                            align="center"
                            label="检验所名称"
                            width="90">
                        </el-table-column>
                        <el-table-column
                            prop="channelName"
                            header-align="center"
                            align="center"
                            label="推广人名称">
                        </el-table-column>
                        <el-table-column
                            prop="totalPrice"
                            header-align="center"
                            align="center"
                            label="订单金额">
                            <template slot-scope="scope">
                            <template>
                                <el-tag size="small" class="tag_highlight" type="info">¥{{scope.row.totalPrice }}</el-tag>
                            </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="payPrice"
                            header-align="center"
                            align="center"
                            label="个人支付金额">
                            <template slot-scope="scope">
                            <template>
                                <el-tag size="small" class="tag_highlight" type="info">¥{{scope.row.payPrice }}</el-tag>
                            </template>
                            </template>
                        </el-table-column>
                        <!-- 支付状态 -->
                        <el-table-column
                            prop="payStatus"
                            header-align="center"
                            align="center"
                            label="订单状态">
                            <template slot-scope="scope">
                                 <template v-for="item in option_payStatus">
                                    <template v-if="scope.row.payStatus == item.value">
                                    <el-tag v-if="item.value == 0" size="small" type="danger">{{item.label}}</el-tag>
                                    <el-tag v-else-if="item.value == 1" size="small" type="success">{{item.label}}</el-tag>
                                    <el-tag v-else size="small" class="tag_highlight"  type="info">{{item.label}}</el-tag>
                                    </template>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="addTime"
                            header-align="center"
                            align="center"
                            label="创建时间"
                            width="160">
                        </el-table-column>
                        <el-table-column
                            prop="userName"
                            header-align="center"
                            align="center"
                            label="联系人">
                        </el-table-column>
                        <el-table-column
                            prop="telNumber"
                            header-align="center"
                            align="center"
                            label="联系电话"
                            width="100">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            header-align="center"
                            align="center"
                            label="联系地址"
                            width="200">
                        </el-table-column>
                        <el-table-column
                            props="agreeReportPerm,reportUrl"
                            header-align="center"
                            align="center"
                            label="报告"
                            width="100">
                             <template  slot-scope="scope" >
                                <span v-if="scope.row.agreeReportPerm !== 1">用户未授权</span>
                                <template v-else>
                                    <span  v-if="scope.row.reportUrl == null">未出报告</span>
                                    <el-button  type="primary" v-else  size="small" class="tag_highlight" @click="lookReport(scope.row.reportUrl)">查看报告</el-button>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="promotionStatus"
                            header-align="center"
                            align="center"
                            label="结算状态">
                            <!-- <template slot-scope="scope">
                                <el-tag v-if="scope.row.promotionStatus === 0" size="small" class="tag_highlight"  type="danger">未结算</el-tag>
                                <el-tag v-if="scope.row.promotionStatus === 1" size="small" class="tag_highlight"  type="success">已结算</el-tag>
                            </template> -->
                            <template slot-scope="scope">
                                <template v-for="item in promotionStatus">
                                    <template v-if="scope.row.promotionStatus == item.value">
                                    <el-tag v-if="item.value === 0" size="small" type="danger">{{item.label}}</el-tag>
                                    <el-tag v-if="item.value === 1" size="small" type="success">{{item.label}}</el-tag>
                                    </template>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="channelPromotionPrice"
                            header-align="center"
                            align="center"
                            label="代理结算金额"
                            v-if="this.type == 0">
                        </el-table-column>
                        <el-table-column
                            prop="dealerPromotionPrice"
                            header-align="center"
                            align="center"
                            label="经销商结算金额">
                        </el-table-column>
                         <el-table-column
                            fixed="right"
                            header-align="center"
                            align="center"
                            label="操作"
                            width="80">
                            <template slot-scope="scope">
                                <template>
                                    <el-button type="text" size="small" @click="confirmAccount(scope.row.id)" v-if="scope.row.promotionStatus === 0">确认结算</el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="form.page"
                        :page-size="form.limit"
                        :total="totalCount"
                        layout="total, prev, pager, next, jumper">
                    </el-pagination>
                </el-main>
            </el-container>
        </el-container>
    </div>

    <!--移动端-->
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>

</div>
</template>

<script>
import axios from 'axios';
import qs from 'qs'
import Tabbar from '@/components/Tabbar.vue';
import "../../assets/css/base.css";
import "@/assets/css/product.css";
import "@/assets/css/index.css?version=1.0.1";
import NavHeader from "@/components/Header.vue";
import NavFooter from "@/components/Footer.vue";
import NavBread from "@/components/Bread.vue";
import '@/assets/css/index.css';
import NavLeft from '@/components/NavLeft.vue';
import {getCookie} from "../../util/util"

export default {
    name: "UserList",
    data() {
        return {
            selected: "Mine",
            tabs: [
              require("@/assets/hose_grey.png"),
              require("@/assets/shopping_grey.png"),
              require("@/assets/me_Filled.png")
            ],
            totalCount:0,
            loading:false,
            type:'',
            dataList:[],
            countList:[],
            tableHeight: 0,
            p_showSearch: true,
            p_loginModalFlag: false,
            p_showNavbar: true,
            hasMoreData: true,
            dataListSelections:[],
            p_activeIndex: '7',
            orderPlatform: 1,
            type:"",
            form: {
                page: 1,
                limit: 9,
                userId: '',
                channelName: '',
                channelType:'',
                orderNum: '',
                userName: '',
                telNumber: '',
                providerName: [],
                beginTime: '',
                endTime:'',
                payStatus:'',
                accountStatus:'',
                channelType:'',
            },

            // 支付状态
            option_payStatus: [{
                    value: 0,
                    label: '待支付'
                    }, {
                    value: 1,
                    label: '已支付'
                    },{
                    value: 2,
                    label: '取消支付'
                }],
            // 结算状态
            promotionStatus:[{
                value:0,
                label:'未结算'
                },{
                value:1,
                label:'已结算'
            }],
            //起始时间
            picker_beginTime: {
                disabledDate: time => {
                    if (this.form.endTime) {
                    return (
                        time.getTime() > new Date(this.form.endTime).getTime()
                    )
                    }
                }
            },
            // 截止时间
            picker_endTime: {
                disabledDate: time => {
                    if (this.form.beginTime) {
                    return (
                        time.getTime() < new Date(this.form.beginTime).getTime()
                    )
                    }
                }
            },
            index:'',
        };
    },
    components: {
        NavHeader,
        NavFooter,
        NavBread,
        NavLeft,
        Tabbar
    },
    mounted() {
      if (getCookie("_token")) {
        this.getDataList()
        this.getPromotionCount()
        setTimeout(() => {
          this.tableHeight = document.documentElement.clientHeight - 300
        }, 100)

      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
    },
    methods: {
        p_showLoginModal() {
            this.p_loginModalFlag = true;
        },

        p_closeLoginModal() {
            this.p_loginModalFlag = false;
        },

        toSearch(itemName, id) {
            this.$router.push({
                path: "search",
                query: {
                    id: id,
                    name: itemName
                }
            });
        },
        // 点击分页
        handleCurrentChange (val) {
            this.form.page = val
            this.getDataList()
        },
        getDataList(index) {
            if (index === 0) {
                this.form.page = 1
            }
            this.index = index
            this.loading = true
            // 获取时间
            const date = new Date()
            const seperator1 = "-"
            const year = date.getFullYear()
            let month = date.getMonth() + 1
            let preMonth = date.getMonth()
            let strDate = date.getDate()
            if (month >= 1 && month <= 9) {
                month = "0" + month
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate
            }
            //获取本月最后一天
            var  day = new Date(year,month,0);
            var lastdate = day.getDate();
            //获取上月最后一天
            var  pday = new Date(year,preMonth,0);
            var pLastDate = pday.getDate()
            //设置统计数据时间范围
            if(index) {
                if (index===1 ||index===4) {
                    this.form.beginTime = year + seperator1 + month + seperator1 + strDate
                    this.form.endTime = year + seperator1 + month + seperator1 + strDate
                }else if (index===2 ||index===5) {
                    this.form.beginTime = year + seperator1 + month + seperator1 + '01'
                    this.form.endTime = year + seperator1 + month + seperator1 + lastdate
                }else if (index===3 ||index===6) {
                    this.form.beginTime = year + seperator1 + preMonth + seperator1 + '01'
                    this.form.endTime = year + seperator1 + preMonth + seperator1 + pLastDate
                }
                if(index===1||index===2||index===3) {
                    this.form.channelType = 0
                }else if (index===4||index===5||index===6){
                    this.form.channelType = 1
                }
            }
            axios.get("/jys/order/promotion",{
                params:{
                    orderPlatform:1,
                    userId:this.form.userId,
                    channelName:this.form.channelName,
                    orderNum:this.form.orderNum,
                    userName:this.form.userName,
                    telNumber:this.form.telNumber,
                    providerName:this.form.providerName,
                    beginTime:this.form.beginTime,
                    endTime:this.form.endTime,
                    accountStatus:this.form.accountStatus,
                    page:this.form.page,
                    limit:this.form.limit,
                    channelType:this.form.channelType
                },
                headers: {
                    "Content-Type": "application/json",
                    'token': getCookie("_token") ? getCookie("_token") : ""
                }
            }).then((res) => {
                console.log(res)
                if(res.data.code == 0) {
                    this.loading = false
                    this.dataList = res.data.page.list
                    this.totalCount =  res.data.page.totalCount
                    this.type = res.data.type
                }
            })
        },
        // 导出
        exportExcel () {
            let url = process.env.API_ROOT + '/jys/order/exportPromotion?orderPlatform=1'
            let ids = this.dataListSelections

            for (let key in this.form) {
            if (!this.form.hasOwnProperty(key)) continue
            url += `${key}=${this.form[key]}&`
            }

            if(ids.length){
            let temp = 'ids=['
            for (let i=0; i<ids.length; i++) {
                temp = temp + ids[i] + ','
            }
            temp = temp + ']'

            location.href = url + temp + `&token=${getCookie("_token")}`
            }else{
            location.href = url.substring(0, url.length - 1) + `&token=${getCookie("_token")}`
            }
        },
        // 清空
        clearInput() {
            this.form = {}
            this.getDataList()
        },
        //多选
        selectionChangeHandle (val) {
            this.dataListSelections = []
            for (let i=0; i<val.length; i++) {
            this.dataListSelections.push(val[i].id)
            }
        },
        // 获取订单统计数
        getPromotionCount( ) {
            axios.get("jys/order/promotionCount",{
                headers: {
                    "Content-Type": "application/json",
                    'token': getCookie("_token") ? getCookie("_token") : ""
                }
            }).then((res) => {
                if(res.data.code == 0) {
                    this.loading = false
                    this.countList = res.data.promotion
                    this.type = res.data.type
                }
            })

        },
        //确认结算
        confirmAccount(id) {
            let ids = Array.of(id)
            let temp = ''
            if(ids.length){
            temp = '['
            for (let i=0; i<ids.length; i++) {
                temp = temp + ids[i] + ','
            }
            temp = temp + ']'
            }
            this.$confirm('此操作将结算订单, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    axios.get("/jys/order/closeAccount",{
                        params:{
                            orderPlatform:1,
                            userId:this.form.userId,
                            channelName:this.form.channelName,
                            orderNum:this.form.orderNum,
                            userName:this.form.userName,
                            telNumber:this.form.telNumber,
                            providerName:this.form.providerName,
                            beginTime:this.form.beginTime,
                            endTime:this.form.endTime,
                            ids:temp,
                        },
                        headers: {
                            "Content-Type": "application/json",
                            'token': getCookie("_token") ? getCookie("_token") : ""
                        }
                    }).then((res) => {
                        console.log(typeof ids)
                        console.log(ids)
                        if( res.data.code == 0) {
                            this.$message({
                            type: 'success',
                            message: '结算成功!',
                            });
                            this.getDataList()
                            this.getPromotionCount()
                        }
                    })
                }).catch(() => {
                    console.log("res")
                this.$message({
                    type: 'info',
                    message: '已取消结算'
                });
            });

        },
        // 查看报告
        lookReport(reportUrl) {
            // window.open(reportUrl,'_blank')
            window.open(reportUrl + '?t=' + new Date().getTime())
        },

    }

}

</script>

<style scoped>
    .census {
        margin-bottom: 23px;
        color: rgb(110, 110, 110);
    }
    .title {
        color: rgb(110, 109, 109);
        padding: 5px 20px;
        /* background-color: rgb(246, 246, 246); */
        font-weight: bold;
    }
    .grid-content {
        text-align: center;
        min-height: 0;
    }
    .one:hover {
        color: #00C5B0;
        cursor: pointer;
    }
    .bottom {
        font-size: 13px;
    }
    .number {
        font-size: 18px;
        /* margin-bottom: 10px; */
        /* padding-top: 15px; */
    }
    .orders,.accounts {
        position: relative;
    }
    .left,.right {
        width: 49%;
    }
    .right {
        position: absolute;
        right: 0;
        top: 0;
    }

    .two {
        color: #00C5B0;
    }
    .orders .left,
    .orders .right {
       border: 1px solid rgb(246, 246, 246);
       border-radius: 5px;
       margin-bottom: 10px;
       box-shadow: 0 0 5px #ddd;
    }
    .orders .title {
        border-bottom: 1px dashed #ddd;
        background-color: rgb(246, 246, 246);
        color: rgb(110, 109, 109);
    }
    .number {
        margin-bottom: 10px;
    }

    .accounts .left,
    .accounts .right {
        margin-bottom: 15px;
        border: 1px solid rgb(246, 246, 246);
        border-radius: 5px;
        box-shadow: 0 0 5px #ddd;
    }
    .mshow{
      display: none;}
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      .userInfo {
        height: 80px;
        margin: 0;
      }
      .container{
         width: 95%;
         margin: 0 auto 70px;
       }
      .el-col-12 {
        width: initial;
      }

      .biaot {
        background-color: #F0F0F0;
        color: #333;
        font-size: 11px;
        text-align: left;
        position: relative;
        line-height: 32px;
        margin: 0 -10px 0;
        padding: 0 10px;
        border-left: 5px solid #00C5B0;
      }
      .mshow{
        display: inline-block;}
      .biaot div {
        position: absolute;
        right: 0;
        height: 32px;
        top: 0;
      }


      .mhide{
        display: none;}
      /deep/ .el-container{
        margin-left: 0!important;
      }
      /deep/ .el-pagination button {
        min-width: initial;
      }
      /deep/ .el-pagination .btn-prev {
        padding-right: 0;
      }
      /deep/ .el-pagination{
        margin-left: 0px;
      }

      /deep/ .el-pagination .btn-next {
        padding-left: 0;
      }
      /deep/ .el-pagination__jump {
        margin-left: 0;
        display: none!important;
      }
      .order-item-title {
        padding: 0 6px;
        font-size: 12px;
      }
      .el-main{
        padding: 10px;
      }
      .total-price {
        white-space: nowrap;
        font-size: 12px;
      }
      .order-item-title span{
        width: 70px;
        overflow: hidden;
        white-space: nowrap;
      }
      /deep/ .el-dialog {
        width: 98%!important;
      }
      /deep/ .el-pager li {
        min-width: 32px;
      }
      .el-input{

        width: 190px!important;
      }
      /deep/ .header a{

        overflow: hidden;
        white-space: nowrap;
      }
      /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel,/deep/ .navbar-left-container .home{
        display: none!important;
      }
      /deep/ .out{
        color: rgba(0, 196, 170, 1);
        padding-left: 0;
        margin-right: 20px;
      }
      /deep/ .el-button--text {
        line-height: 11px;
      }

      /deep/ .el-pager li {
        min-width: 32px;
      }
      .el-input{

        width: 190px!important;
      }
      /deep/ .header a{

        overflow: hidden;
        white-space: nowrap;
      }
      /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel,/deep/ .navbar-left-container .home{
        display: none!important;
      }
      /deep/ .out{
        color: rgba(0, 196, 170, 1);
        padding-left: 0;
        margin-right: 20px;
      }
      /deep/ .el-button--text {
        line-height: 11px;
      }

      /deep/ .el-dialog {
        width: 98%!important;
      }

      /deep/ .el-dialog__body {
        padding: 10px;
      }

      /deep/ .el-row {
        display: flex;
      }

      /deep/ .el-col-12 {
        width: 100%;
      }

      /deep/ .el-date-editor.el-input {
        width: 100%;
      }

      /deep/ .el-input--small {
        font-size: 14px;
      }
      /deep/ .el-pagination__total{
        display: none!important;
      }
      /deep/ .el-container{
        margin-left: 0!important;
      }
      /deep/ .el-pagination button {
        min-width: initial;
      }
      /deep/ .el-pagination .btn-prev {
        padding-right: 0;
      }
      /deep/ .el-pagination{
        margin-left: 0px;
        margin-top: 10px;
      }
      /deep/ .el-pagination .btn-next {
        padding-left: 0;
      }
      /deep/ .el-pagination__jump {
        margin-left: 0;
      }
      /deep/ .el-pager li {
        min-width: 32px;
      }
      /deep/ .left,.right{
        width: 100%!important;
        position:static;
      }
      .right[data-v-d12952ce] {
        position:static;
      }
      .mhide{
        display: none;
      }
      .ddh{
        margin-left: -28px;
        width: 200px;
      }
      .nu {
          width: 100%;
      }
      .el-col-8 {
          width: 100%;
      }

      /deep/ #home {
        display: none !important;
      }
    }


</style>



// WEBPACK FOOTER //
// src/pages/user/UserList.vue